/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */

export type AvailableIncidentFiltersDataDtoSeveritiesItem = typeof AvailableIncidentFiltersDataDtoSeveritiesItem[keyof typeof AvailableIncidentFiltersDataDtoSeveritiesItem];


export const AvailableIncidentFiltersDataDtoSeveritiesItem = {
  minor: 'minor',
  major: 'major',
  critical: 'critical',
} as const;
